module.exports = __webpack_public_path__ + "img/authority-none.cca0c4ac.svg";